<template>
  <a-modal class="satisfaction-model" v-model="isShowSatisfaction" :bodyStyle="{padding: 0}"
           width="620px" :footer="null" :closable="false">
    <div class="top-back"></div>
    <div class="model-content">
      <div class="evaluateInvite">
        {{ feedBackConfig.evaluateInvite ? inviteTips : '' }}
      </div>
      <div v-if="isShowSubject">
        <div class="subject-list" v-for="(item, index) in subjectList" :key="index">
          <div :class="['label', index === 0 ? 'header-name': '']">{{item.subjectName}}</div>
          <star v-model="item.sorce"></star>
          <div class="sorceText">{{sorceTextFn(item.sorce)}}</div>
        </div>
      </div>
      <template v-if="feedBackConfig.dissatisfiedCause && isShowReason && unsatisfyReason.length > 0">
        <div class="un-reason-tip">{{$t('dissatisfyReason')}}</div>
        <div class="reason-btn-page">
          <div class="reason-btn" v-for="item of unsatisfyReason"
               :class="{active:item.active}" @click="btnReason(item)" :title="item.text">{{item.text}}</div>
        </div>
      </template>
      <a-textarea v-if="feedBackConfig.opinionFeedback" class="reason-feed" v-model="feedback" :placeholder="feedPlaceholder"></a-textarea>
      <div class="solve-container" v-if="isSolveShow">
        <div class="solve-title">{{$t('isSolved')}}</div>
        <div class="solve-result">
          <div @click="solveFn(true)" class="solve-result-list" :class="{active: isSolve}">
            <img v-if="isSolve" class="solve-icon" :src="require('@/assets/img/good-active.png')">
            <img v-else class="solve-icon" :src="require('@/assets/img/good.png')">
            {{$t('solved')}}
          </div>
          <div @click="solveFn(false)" class="solve-result-list" :class="{active: !isSolve}">
            <img v-if="!isSolve" class="solve-icon" :src="require('@/assets/img/bad-active.png')">
            <img v-else class="solve-icon" :src="require('@/assets/img/bad.png')">
            {{$t('unsolved')}}
          </div>
        </div>
      </div>
      <!-- <div class="evaluateThank" v-if="feedBackConfig.evaluateThank">{{evaluateThank}}</div> -->
      <div class="submite-container">
        <a-button style="margin-right: 20px" @click="closeDown">{{$t('CLOSE')}}</a-button>
        <a-button type="primary" @click="submitFeed">{{$t('OK')}}</a-button>
      </div>
    </div>
  </a-modal>
</template>
<script>
import ajax from '@/ajax/axios-ajax.js'
import apis from '@/apis/index.js'
import { mapState, mapGetters, mapMutations } from 'vuex'
import star from '../common/star'
export default {
  data () {
    return {
      score: 5,
      formatScore: 0,
      feedback: '',
      isFeedback: false,
      feedPlaceholder: '',
      isReason: false,
      unsatisfyReason: [],
      inviteTips: this.$t('commentService'),
      isShowSatisfaction: false, // 是否显示满意度弹框
      evaluateThank: '',
      isShowThank: false,
      subjectList: [],
      isShowSubject: false,
      isSolve: true,
      isSolveShow: true
    }
  },
  computed: {
    ...mapState({
      visitorInfo: 'visitorInfo',
      feedBackConfig: 'feedBackConfig' // 满意度权限
    }),
    ...mapGetters({
      serviceId: 'serviceId',
      agentJobNum: 'agentJobNum',
      agentId: 'agentId', //客服编码
      agentName: 'agentName', //客服名称
      serviceTime: 'serviceTime'
    }),
    isShowReason () {
      if (this.subjectList.length === 0) {
        return false
      } else {
        let isTrue = false
        this.subjectList.forEach((ev) => {
          isTrue = isTrue || ev.sorce < 4
        })
        return isTrue
      }
    }
  },
  methods:{
    ...mapMutations({
      deleteKey_noticeEvaluate: 'deleteKey_noticeEvaluate'
    }),
    sorceTextFn (v) {
      if (+v === 1) {
        return this.$t('veryDissatisfied')
      } else if (+v === 2) {
        return this.$t('notSatisfied')
      } else if (+v === 3) {
        return this.$t('general')
      } else if (+v === 4) {
        return this.$t('satisfied')
      } else if (+v === 5) {
        return this.$t('verySatisfied')
      }
    },
    openUp (data = []) {
      this.isSolve = true
      this.feedback = ''
      let isSolveArr = data.filter((item) => {
        return item.configCode === 'solve.ask'
      })
      switch(isSolveArr[0].configInfo){
        case '1':
          this.isSolve = false
          break;
        case '0':
          this.isSolve = true
          break;
      }
      let defalultsArr = data.filter((item) => {
        return item.configCode === 'relative.value'
      })
      let defalultsObj = defalultsArr.length > 0 ? defalultsArr[0] : {}
      data.forEach((ev) => {
        if (ev.configCode === 'criterion') { // 评价标准
          this.formatScore = +ev.configValue
        } else if (ev.configCode === 'dissatisfied.cause') { // 不满意原因
          this.isReason = !!ev.enable
          if (ev.configValue) {
            this.unsatisfyReason = ev.configValue.split(',').map((v) => {
              return {
                active: false,
                text: v
              }
            })
          } else {
            this.unsatisfyReason = []
          }
        } else if (ev.configCode === 'opinion.feedback') { // 意见反馈框
          this.isFeedback = !!ev.enable
          this.feedPlaceholder = ev.configValue || ev.configInfo
        } else if (ev.configCode === 'evaluate.thank') { // 评价感谢语
          this.isShowThank = !!ev.enable
          this.evaluateThank = ev.configValue || ev.configInfo
        } else if (ev.configCode === 'evaluate.invite') { // 评价提示语
          this.inviteTips = ev.configValue || ev.configInfo
        } else if (ev.configCode === 'evaluate.subject') {
          this.isShowSubject = ev.enable === 1
          this.subjectList =ev.configInfo ? JSON.parse(ev.configInfo).map((item, index) => {
            let sorce = defalultsObj.configValue || defalultsObj.configInfo || 0
            return {
              subjectName: item.subjectName,
              sorce,
              subjectId: item.id
            }
          }) : []
        } else if (ev.configCode === 'solve.ask') {
          this.isSolveShow = ev.enable === 1
        }
      })
      this.isShowSatisfaction = true;
    },
    solveFn (v) {
      this.isSolve = v
    },
    closeDown () {
      this.deleteKey_noticeEvaluate(this.serviceId)
      this.isShowSatisfaction = false;
    },
    clickStar (i) {
      this.score = i;
    },
    btnReason (item) {
      item.active= !item.active
    },
    async getFeed(){
      this.score = 5
      this.feedback = ''
      let params = {
        tenantId: this.visitorInfo.tenantId ? this.visitorInfo.tenantId : '',
        visitorId: this.visitorInfo.visitorId
      }
      let res = await ajax.get(apis.satisfaction.configInfo, {params})
      if (res.success){
        this.openUp(res.data)
      }
    },
    async submitFeed () {
      let newReason = [];
      this.unsatisfyReason.forEach((ev)=>{
        if(ev.active){
          newReason.push(ev.text)
        }
      })
      let request = {
        satisfacte: {
          agentId: this.agentId,
          agentJobNum: this.agentJobNum,
          tenantId: this.visitorInfo.tenantId,
          agentName: this.agentName,
          isSolve: this.isSolveShow ? +this.isSolve : undefined,
          feedback: this.feedback,
          serviceId: this.serviceId,
          serviceTime: this.serviceTime,
          groupId: this.visitorInfo.groupId,
          groupName: this.visitorInfo.groupName,
          visitorId: this.visitorInfo.visitorId,//访客编码
          visitorName: this.visitorInfo.visitorName,//访客姓名
          unsatisfyReason:  this.isShowReason ? newReason.join(',') : ''
        },
        subjectList: this.subjectList
      }
      let res = await ajax.post(apis.satisfaction.saveSatisfaction, request)
      if (res.success) {
        this.$message.success(res.message)
        this.closeDown()
      } else {
        this.$message.error(res.message)
      }
    }
  },
  mounted:function () {
    this.$bus.$on('showFeed', (msg) => {
      this.getFeed()
    })
    this.$bus.$on('showFeedBySocket', (msg) =>{
      this.score = 5
      this.feedback = ''
      this.openUp(msg)
    })
  },
  created () {
    this.$bus.$off('showFeed')
    this.$bus.$off('showFeedBySocket')
  },
  components: {
    star
  }
}
</script>
<style scoped lang="less">
  .header-name {
    font-weight: bold;
  }
  .top-back{
    height: 145px;
    background: top url("../../../assets/img/topBack-satifaction.png") no-repeat;
    background-size: 100% auto;
  }
  .model-content{
    padding: 18px 40px 40px 40px;
    line-height: 1;
  }
  .feed-back{
    width: 16rem;
    background-color: #fff;
    border: 1px solid #ddd;
    border-radius: 0.2rem;
    padding: 0.5rem;
    background-color: #fff;
    text-align: left;
    position: relative;
  }
  .evaluateInvite{
    color: #999;
    font-size: 14px;
    margin-bottom: 40px;
  }
  .solve-container{
    margin-top: 40px;
    .solve-title{
      color: #333;
      font-size: 14px;
    }
    .solve-result{
      display: flex;
      justify-content: space-between;
      padding: 20px 0 20px 129px;
      width: 350px;
    }
  }
  .solve-result-list{
    color: #bfbfbf;
    cursor: pointer;
    font-size: 20px;
    &.active{
      color: #222;
      .fa{
        color: #109cff;
      }
    }
  }


  .reason-feed{
    margin-top: 10px;
    height: 100px;
  }
  .satisfaction-text{
    line-height: 1.4;
    cursor: pointer;
    text-align: center;
    .radio-page{
      margin-right: 20px;
    }
  }
  .satisfaction-num{
    margin-top: 10px;
    cursor: pointer;
    text-align: center;
    .radio-page{
      margin-right: 40px;
    }

  }
  .subject-list{
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    .label{
      width: 115px;
      color: #333333;
      font-size: 16px;
      margin-right: 15px;
      text-align: center;
    }
    .sorceText{
      padding-left: 20px;
      color: #333;
      font-size: 14px;
    }
  }
  .un-reason-tip{
    font-size: 14px;
    color: #333
  }
  .reason-btn-page{
    margin-top: 20px;
    .reason-btn{
      cursor: pointer;
      width: 170px;
      height: 36px;
      border: 1px solid #ddd;
      text-align: center;
      line-height: 36px;
      display: inline-block;
      border-radius: 5px;
      margin-right: 10px;
      font-size: 14px;
      overflow: hidden;
      word-break: break-all;
      white-space: nowrap;
      text-overflow: ellipsis;
      &.active{
        border-color: #109cff;
        background-color: #d9efff;
      }
    }
  }
  .submite-container{
    margin-top: 40px;
    text-align: center;
  }
  .evaluateThank{
    margin-top: 20px;
    color: #999999;
  }
  .solve-icon{
    width: 26px;
    height: 26px;
  }
</style>
<style lang="less">
  .satisfaction-model {
    .ant-modal-content {
      overflow: hidden;
      border-radius: 20px;
    }
  }
</style>
